import {
    Card,
    CardBody,
    Col,
    Row,
} from 'reactstrap';

import VerificationStatusBanner from '../VerificationStatusBanner';
import CallAttempts from './CallAttempts';
import CallVerificationAside from './CallVerificationAside';

const HumanIdentity = ({
    bid,
}) => {
    const {
        alert,
        attempts,
        checklist,
        nextSteps,
        phone,
    } = bid.callVerification;

    return (
        <Row>
            <Col xl="8">
                <VerificationStatusBanner outcome={alert} />

                <Card>
                    <CardBody>
                        <CallAttempts attempts={attempts} phone={phone.number} />
                    </CardBody>
                </Card>
            </Col>

            <Col xl="4">
                <CallVerificationAside
                    checklist={checklist}
                    nextSteps={nextSteps}
                    phone={phone}
                />
            </Col>
        </Row>
    );
};

export default HumanIdentity;
